import { render, staticRenderFns } from "./RingPieEchart.vue?vue&type=template&id=c23c75bc"
import script from "./RingPieEchart.vue?vue&type=script&lang=js"
export * from "./RingPieEchart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports